const PROMO_CONFIG = {
    selectors: '.promo-cta button, .pdp-promo__cta button',
    colors: ['#fa8900', '#e1001a'],
    rainDuration: 500,
    redirectDelay: 4000
};


function triggerConfettiRain() {
    return new Promise((resolve) => {
        const end = Date.now() + PROMO_CONFIG.rainDuration;

        (function frame() {
            confetti({
                particleCount: 2,
                angle: 60,
                spread: 70,
                origin: { x: 0 },
                colors: PROMO_CONFIG.colors
            });
            confetti({
                particleCount: 2,
                angle: 120,
                spread: 70,
                origin: { x: 1 },
                colors: PROMO_CONFIG.colors
            });

            if (Date.now() < end) {
                requestAnimationFrame(frame);
            } else {
                resolve();
            }
        }());
    });
}


async function handlePromoClick(event) {
    const btn = event.currentTarget;
    const discountCode = btn.dataset.discount;
    const pdpPromo = btn.closest('.pdp-promo');
    const pdpPromoTitle = pdpPromo?.querySelector('.pdp-promo__title');
    const pdpPromoDesc = pdpPromo?.querySelector('.pdp-promo__desc');
    const pdpPromoCta = pdpPromo?.querySelector('.pdp-promo__cta');
    const copiedTextTemplate = btn.dataset.copiedText;
    const discountPercentage = parseFloat(btn.dataset.discountPercentage) || 0;
    const productPrice = parseFloat(btn.dataset.productPrice) || 0;

    if (!discountCode) return;

    try {
        await navigator.clipboard.writeText(discountCode);

        btn.disabled = true;

        if (pdpPromoTitle) {
            pdpPromoTitle.classList.add('is-hidden');
        }

        await triggerConfettiRain();

        const cart = await applyDiscountAjax(discountCode);
        let shouldHideCta = false;

        if (discountPercentage && productPrice && pdpPromoDesc && copiedTextTemplate) {
            let savings = productPrice * discountPercentage;
            let finalPrice = productPrice - savings;

            const locale = `${Shopify.locale}-${Shopify.country}`;

            finalPrice = finalPrice.toLocaleString(locale, {
                style: 'currency',
                currency: Shopify.currency.active
            });

            savings = savings.toLocaleString(locale, {
                style: 'currency',
                currency: Shopify.currency.active
            });

            pdpPromoDesc.textContent = copiedTextTemplate.replace('[price]', finalPrice).replace('[total_saved]', savings);
            shouldHideCta = true;
        } else if (cart) {
            shouldHideCta = true;
        }

        if (shouldHideCta && pdpPromoCta) {
            pdpPromoCta.classList.add('is-hidden');
        }

        if (cart) {
            refreshThemeCart(cart);
        }

    } catch (err) {
        console.error('Something failed:', err);
    }
}

function refreshThemeCart(cart) {
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
            baseEvent: "discount:apply",
            cart
        }
    }));

    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true
    }));
}

async function applyDiscountAjax(discountCode) {
    try {
        const sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
            bubbles: true,
            detail: { sections: sectionsToBundle }
        }));

        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                discount: discountCode,
                sections: sectionsToBundle.join(',')
            })
        });

        if (!response.ok) throw new Error('Failed to apply discount');

        const cart = await response.json();
        return cart;

    } catch (err) {
        console.error('Discount apply failed:', err);
        return null;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const promoBtns = document.querySelectorAll(PROMO_CONFIG.selectors);
    promoBtns.forEach(btn => btn.addEventListener('click', handlePromoClick));
});